module.exports = __webpack_public_path__ + "img/01-capsule-3-base.8b35729e.svg";